import { render } from "./CarouselSkeleton.vue?vue&type=template&id=24e58eae&scoped=true"
import script from "./CarouselSkeleton.vue?vue&type=script&lang=js"
export * from "./CarouselSkeleton.vue?vue&type=script&lang=js"

import "./CarouselSkeleton.vue?vue&type=style&index=0&id=24e58eae&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-24e58eae"]])

export default __exports__